import type { ReactNode } from "react";
import { formatRelativeTime } from "@/lib/freshness";
import { SimpleTooltip } from "./tooltip";

interface TimestampProps {
  date: Date | string | null | undefined;
  className?: string;
  /** Override the relative text (e.g. "Crawled 2 days ago"). Defaults to formatRelativeTime output. */
  children?: ReactNode;
  /** Whether to show a tooltip with full localized timestamp. Defaults to true. */
  tooltip?: boolean;
}

export function Timestamp({
  date,
  className,
  children,
  tooltip = true,
}: TimestampProps) {
  if (!date) return null;
  const d = typeof date === "string" ? new Date(date) : date;
  if (Number.isNaN(d.getTime())) return null;

  const iso = d.toISOString();
  const content = (
    <time dateTime={iso} className={className}>
      {children ?? formatRelativeTime(d)}
    </time>
  );

  if (!tooltip) {
    return content;
  }

  const formatted = d.toLocaleString(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  });

  return <SimpleTooltip content={formatted}>{content}</SimpleTooltip>;
}
